export const detectTaskboardIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete taskboard" || cleaned === "remove taskboard") {
        return { intent: "delete_taskboard" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) taskboard/);
    if (deleteMatch) {
        return { intent: "delete_taskboard", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create taskboard") || cleaned.includes("add taskboard")) {
        return { intent: "create_taskboard" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create taskboard named (.+)/);
    if (createMatch) {
        return { intent: "create_taskboard", name: createMatch[1].trim() };
    }

    return null;
};
